<template>
  <div>
    <button class="btn btn-sm btn-info"
     @click="req"
     :class="{'disabled': loading}">
      <div class="flex ai-center">
        <span>
          <slot></slot>
        </span>
        <div v-if="loading" class="spinner-border m-l-2" role="status" style="width: 15px;height: 15px;border-width: 2px;">
          <span class="visually-hidden"></span>
        </div>
      </div>
    </button>
  </div>
</template>
<script>
  import { errorNotify } from "@/plugins/functions";
  export default{
    props: {
      url: {
        default: "",
      },
      text: {
        default: "",
      },
      params:{
        default: function(){
          return {};
        }
      },
    },
    data(){
      return {
        loading: false,
      }
    },
    methods:{
      req() {  
        let params = this.params ? this.params : {};
        console.log(this.url)
        if(!this.url)
          return
        this.loading = true;
        this.$http
          .post(this.url, { params })
          .then((response) => {
            if (response.data) {
              this.data = response.data.data;
            }
            this.$notify({
              title: "Данные",
              message: text ? text : "Синхронизация прошла успешно",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          })
          .catch((error) => {
            errorNotify(error, this.$notify);
            return null;
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 400);
          });
      },
    }
  }
</script>
<style lang="scss">
  .btn-info{
    &.disabled{
      pointer-events: none;
    }
  }
</style>